import { flutterColorToHex } from "../config/theme";
import Icon1 from "../icons/Icon";
import { getVeryLightVersion } from "../models/ColorFunctions";
import { isColorTooDark } from "../models/OrgFunctions";

export const PlanningEvent = ({
  highligtedEvent,
  event,
  pack_short_dict,
  events_colors,
  height,
  simplified_view,
  masterData,
  rdv = false,
}) => {
  const timeToMinutes = (time) => {
    if (!time) return 0; // If time is undefined or null, return 0 (or handle as needed)

    const [hours, minutes] = time.split(":").map(Number); // Safely split the time
    return hours * 60 + minutes;
  };

  const timeIntervaltoMinutesOrHours = (time1, time2) => {
    if (!time1) return 0; // If time is undefined or null, return
    if (!time2) return 0; // If time is undefined or null, return 0 (or handle as needed)
    const minutes1 = timeToMinutes(time1);
    const minutes2 = timeToMinutes(time2);
    const diff = minutes2 - minutes1;
    if (diff < 60) {
      return diff + "min"; // Return minutes if the difference is less than 60
    } else {
      return Math.floor(diff / 60) + "h " + (diff % 60) + "min"; // Return hours and remaining minutes
    }

    // 0 (or handle as needed)
    // if under one hour, return minutes, else return hours
  };

  function getHeight(minutes) {
    let event_h = height * (minutes / 12450);
    return event_h;
  }

  function getIconSize() {
    return simplified_view ? 13 : 15;
  }

  function getColor(event) {
    return events_colors
      ? events_colors[event.id]
        ? events_colors[event.id]?.length <= 1
          ? flutterColorToHex(events_colors[event.id][0])
          : "black"
        : "black"
      : "black";
  }

  if (event.type === "Trajet") {
    return (
      <div
        className={`relative select-none w-full rounded-md px-1 flex flex-col`}
        style={{
          height: `${getHeight(
            timeToMinutes(event.endTime) - timeToMinutes(event.startTime) - 5
          )}rem`,
          borderLeftColor: rdv
            ? "#3edbfa"
            : getColor(event) === "black"
              ? "transparent"
              : getColor(event),
          borderLeftWidth: "4px",
          backgroundImage: `repeating-linear-gradient(
          45deg,
       ${getVeryLightVersion(getColor(event))}  ,
        ${getVeryLightVersion(getColor(event))}  10px,
          #ffffff 10px,
          #ffffff 20px
        )`,
        }}
      >
        {!simplified_view && (
          <div className="text-h4 text-shadow_50 m-1 flex flex-row gap-2 items-center bg-white rounded-md px-1 py-0.5 w-fit">
            <Icon1 icon_name="car" fill="grey"></Icon1> {event.name}{" "}
            {
              // duration
              timeIntervaltoMinutesOrHours(event.startTime, event.endTime)
            }{" "}
          </div>
        )}
      </div>
    );
  }

  return (
    <div
      className={`bg-white relative select-none  hover:bg-slate-50 w-full rounded-md shadow-md px-1  ${highligtedEvent ? (highligtedEvent === event.id ? "outline-2 shadow-2xl outline-none rounded-md outline-indigo-300 hover:border-indigo-400" : "opacity-25") : "hover:border-1 hover:border-indigo-200"} flex flex-col `}
      style={{
        height: `${getHeight(timeToMinutes(event.endTime) - timeToMinutes(event.startTime) - 5)}rem`,
        backgroundColor: `${rdv ? "#c4f3fd" : event.type === "Pause déjeuner" ? "#ffe1b6" : event.type === "Bureau" ? "#e6ddd4" : event.type === "Réunion technique" ? "#f5e6d0" : event.type === "Rendez-vous privé" ? "#e9d8fd" : event.type !== "Intervention" ? "#f6f6f6" : getVeryLightVersion(getColor(event))}`,
        borderLeftColor: rdv
          ? "#3edbfa"
          : event.type === "Bureau"
            ? "#9c8978"
            : event.type === "Réunion technique"
              ? "#c49a6c"
              : event.type === "Rendez-vous privé"
                ? "#805ad5"
                : getColor(event) === "black"
                ? "transparent"
                : getColor(event),
        borderLeftWidth: "4px",
      }}
    >
      {events_colors && events_colors[event.id]?.length > 1 && (
        <div
          style={{
            height: `${getHeight(timeToMinutes(event.endTime) - timeToMinutes(event.startTime) - 5)}rem`,
          }}
          className="flex flex-col w-1 z-10 absolute -left-1 gap-0 rounded-xl"
        >
          {events_colors[event.id].map((color, index) => {
            return (
              <div
                key={index}
                className="h-full w-1 rounded-xl"
                style={{
                  backgroundColor: flutterColorToHex(color),
                }}
              ></div>
            );
          })}
        </div>
      )}
      <div
        className={`text-h6   text-white rounded-t-md border-0 shadow-none min-h-fit h-fit flex  max-w-full overflow-hidden px-0  `}
        style={{
          backgroundColor: "transparent",
          color: "grey",
        }}
      >
        <div
          className={`  flex flex-row    ${simplified_view ? "text-h6 h-3 " : "text-h4"}  justify-between `}
        >
          <div className={`min-w-fit text-shadow_75      `}>
            {event.startTime} - {event.endTime}{" "}
          </div>
          <div className=" ml-2 text-nowrap text-clip max-w-full overflow-hidden">
            {(pack_short_dict && pack_short_dict[event.pack_ref?.id]) || ""}
          </div>
        </div>
      </div>
      <div className={`  h-full flex flex-col  max-h-[70%] `}>
        <div
          className={` ${simplified_view ? "text-h6 text-nowrap  " : "text-h4"} font-semibold  overflow-hidden text-shadow_75 flex flex-row gap-2 max-h-full `}
        >
          <div
            className={`break-all h-fit min-h-fit ${event.cancelled ? "line-through text-red-600" : ""}`}
          >
            {event.cancelled && (
              <span className="not-italic no-underline font-bold text-red-600 mr-1">
                ANNULÉ ·
              </span>
            )}
            {event.name}
          </div>

          {event.type === "Pause déjeuner" && (
            <div className="flex  justify-end   items-end flex-row  rounded-full w-fit ">
              <Icon1
                icon_name="pizza"
                fill={"grey"}
                size={getIconSize()}
              ></Icon1>
            </div>
          )}
        </div>

        <div className={` flex flex-col`}>
          {getHeight(
            timeToMinutes(event.endTime) - timeToMinutes(event.startTime)
          ) > 5 && (
            <div
              className={`text-h6 text-shadow_50  ${simplified_view ? " text-nowrap  " : ""}`}
            >
              {event.postal} {event.ville}
            </div>
          )}
          {getHeight(
            timeToMinutes(event.endTime) - timeToMinutes(event.startTime)
          ) > (simplified_view ? 3 : 8) &&
            event.type === "Intervention" && (
              <div className="text-h6 text-shadow_50">{event.client_name}</div>
            )}
          <div className="flex flex-row justify-between w-full">
            <div
              className={`absolute  w-full right-1 ${simplified_view ? "pl-0 bottom-0" : "pl-5 bottom-2"} flex-grow  flex-row justify-end flex`}
            >
              <div className="flex justify-end items-end flex-row  rounded-full w-full ">
                <div className="flex ">
                  {event.revision && (
                    <div
                      style={{
                        backgroundColor: `${event.type === "Pause déjeuner" ? "#ffe1b6" : event.type === "Bureau" ? "#e6ddd4" : event.type === "Réunion technique" ? "#f5e6d0" : event.type === "Rendez-vous privé" ? "#e9d8fd" : event.type !== "Intervention" ? "#fff" : getVeryLightVersion(getColor(event))}`,
                      }}
                      className="flex flex-row gap-1  rounded-md pl-1  items-center"
                    >
                      <Icon1
                        icon_name="restauration"
                        fill={"black"}
                        size={getIconSize()}
                      ></Icon1>
                      <div className=" text-h5 text-shadow_50 ">
                        {event.revision.replace("Non conformité ", "")}
                      </div>
                    </div>
                  )}
                </div>
                <div className="flex flex-row">
                  <Icon1
                    icon_name="restart"
                    fill={
                      [
                        "daily",
                        "weekly",
                        "weekly2",
                        "weekly3",
                        "monthly",
                        "weekly5",
                        "weekly6",
                      ].includes(event.frequency)
                        ? "black"
                        : "transparent"
                    }
                    size={15}
                  ></Icon1>
                  {event.type === "Intervention" && (
                    <>
                      {event.reglement_state === "done" ? (
                        <div
                          className={` ${simplified_view ? "w-3" : "w-5"} relative `}
                        >
                          <div className="absolute  1">
                            <Icon1
                              icon_name="done"
                              fill={"black"}
                              size={getIconSize()}
                            ></Icon1>
                          </div>
                          <div className="absolute right-0.5 ">
                            <Icon1
                              icon_name="done"
                              fill={"black"}
                              size={getIconSize()}
                            ></Icon1>
                          </div>
                        </div>
                      ) : (
                        <>
                          {" "}
                          <Icon1
                            icon_name="done3"
                            fill={event.rdv_confirmed ? "black" : "#c4c4c4"}
                            size={getIconSize()}
                          ></Icon1>{" "}
                          <Icon1
                            icon_name="folder"
                            fill={event.folder ? "black" : "#c4c4c4"}
                            size={getIconSize()}
                          ></Icon1>{" "}
                          <Icon1
                            icon_name="document"
                            fill={
                              event.documents_completed ? "black" : "#c4c4c4"
                            }
                            size={getIconSize()}
                          ></Icon1>
                          <Icon1
                            icon_name="cloche"
                            fill={event.reminder ? "black" : "#c4c4c4"}
                            size={getIconSize()}
                          ></Icon1>
                          <Icon1
                            icon_name="control"
                            fill={event.cid ? "black" : "#c4c4c4"}
                            size={getIconSize()}
                          ></Icon1>
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>{" "}
            </div>{" "}
          </div>{" "}
        </div>
      </div>
    </div>
  );
};
